import {
  MenuButtonAddTable,
  MenuButtonBold,
  MenuButtonBulletedList,
  MenuButtonHorizontalRule,
  MenuButtonItalic,
  MenuButtonOrderedList,
  //MenuButtonImageUpload,
  MenuButtonRemoveFormatting,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectFontSize,
  MenuSelectHeading,
  MenuSelectTextAlign,
} from "mui-tiptap";

export default function EditorMenuControls() {
  return (
    <MenuControlsContainer>
      <MenuButtonBold />
      <MenuButtonItalic />
      <MenuButtonHorizontalRule />
      <MenuDivider />
      <MenuSelectFontSize />
      <MenuSelectHeading />
      <MenuDivider />
      <MenuButtonOrderedList />
      <MenuButtonBulletedList />
      <MenuSelectTextAlign />
      <MenuDivider />
      <MenuButtonRemoveFormatting />
      <MenuButtonAddTable />
      {/* Add more controls of your choosing here */}
    </MenuControlsContainer>
  );
}
